<template>
    <div>
        <b-modal
            id="createInvoiceModal"
            ref="createInvoiceModal"
            :lazy="true"
            :title="title"
            title-tag="h2"
            no-close-on-backdrop
        >
            <!-- Modal Form -->
            <transition name="slide-fade">
                <invoice
                    ref="invoice"
                    v-if="page == 'invoice'"
                    :data="data"
                    @loading="loading = true"
                    @loaded="loading = false"
                    class="pl-2"
                />
                <bundle
                    ref="bundle"
                    v-if="page == 'bundle'"
                    :data="bundle_data"
                    :app-data="data"
                    :isEstimate="data.isEstimate"
                    @loading="loading = true"
                    @loaded="loading = false"
                    class="pl-2"
                />
            </transition>
            <div slot="modal-footer" class="w-100">
                <b-button
                    v-if="!loading"
                    @click="$refs.createInvoiceModal.hide()"
                    class="float-left"
                    variant="secondary"
                    >Cancel</b-button
                >
                <div class="float-right">
                    <img v-if="loading" src="assets/ajax-loader.gif" />
                    <div v-else>
                        <b-btn
                            @click="back"
                            v-if="page != 'invoice'"
                            variant="primary"
                            >Back</b-btn
                        >&nbsp;
                        <b-btn
                            @click="save"
                            v-if="page == 'bundle' || isBundle"
                            variant="primary"
                            :disabled="
                                page == 'bundle' &&
                                bundle_data.selectedElements.length === 0
                            "
                            >Save</b-btn
                        >
                        <b-btn @click="next" v-else variant="primary"
                            >Next</b-btn
                        >
                    </div>
                </div>
            </div>
        </b-modal>
        <multipleRequisitionForm ref="multipleRequisitionFormWindow" />
    </div>
</template>
<style></style>
<script>
import _ from "lodash";
import Invoice from "@/components/new-invoice/invoice-create.vue";
import Bundle from "@/module/commons/bundle/bundle";
import MultipleRequisitionForm from "@/module/commons/print_multiple_requisition_form.vue";
import ScheduleHelper from "@/module/schedule/helper";
import LabMixin from "@/mixins/lab";
export default {
    components: {
        Invoice,
        Bundle,
        MultipleRequisitionForm
    },
    mixins: [ScheduleHelper, LabMixin],
    props: {
        client: {
            default: null
        }
    },
    data() {
        return {
            page: "invoice",
            title: "New Invoice",
            data: {
                id: null,
                isShortcut: 1,
                title: "Invoice",
                isEstimate: false,
                client: null,
                patient: null,
                location: null,
                start: null,
                expire: null,
                bundle_id: [],
                note: null,
                status: 1,
                action_status: 1,
                staff: null,
                soap: "",
                isDefaultProvider: false
            },
            bundle_data: {
                bundle_id: null,
                selectedElements: [],
                elements: []
            },
            datePickerOptions: {
                format: "DD/MM/YYYY"
            },
            loading: false
        };
    },
    computed: {
        isBundle() {
            if (this.data.bundle_id.length > 0) {
                return false;
            }

            return true;
            // return !this.data.bundle_id;
        }
    },
    methods: {
        open(event) {
            this.datePickerOptions.format = this.getDateFormat();

            this.page = "invoice";
            //this.data.staff = this.$root.currentActor;

            this.$nextTick(() => {
                if (this.client) {
                    let fullName =
                        this.client.firstname + " " + this.client.lastname;
                    this.data.client_id = this.client.id;
                    this.data.client = {
                        id: this.client.id,
                        label: this.fullName,
                        fullName
                    };
                }
            });
            this.$refs.createInvoiceModal.show();
        },
        next() {
            let self = this;
            let proceed = true;
            if (self.page == "invoice") {
                self.$refs.invoice.$validator.validateAll().then(result => {
                    if (result) {
                        if (!self.data.start) {
                            proceed = false;
                        } else {
                            if (!moment.isMoment(self.data.start)) {
                                self.data.start = moment(
                                    self.data.start,
                                    self.datePickerOptions.format
                                );
                            }
                        }

                        if (
                            self.data.bundle_id.length > 0 &&
                            self.data.bundle_id != null &&
                            !self.data.patient
                        ) {
                            proceed = false;
                            $("#patient_id").addClass("border-danger");
                        } else {
                            $("#patient_id").removeClass("border-danger");
                        }

                        if (proceed) {
                            self.bundle_data.bundle_id = self.data.bundle_id;

                            self.page = "bundle";
                            self.title = "New Bundle";

                            $(".modal-content").removeAttr("tabindex");
                        }
                    }
                });
            }
        },
        back() {
            if (this.page == "bundle") {
                this.page = "invoice";
                this.title = "New Invoice";
            }
        },
        async save() {
            let self = this;
            let promise = true;
            let response = null;
            let proceed = true;
            self.loading = true;

            promise = await self.$validator.validateAll();

            if (self.page == "bundle") {
                promise = await self.$refs.bundle.$validator.validateAll();
            } else {
                promise = await self.$refs.invoice.$validator.validateAll();
            }

            if (promise) {
                if (!self.data.start) {
                    proceed = false;
                } else {
                    if (!moment.isMoment(self.data.start)) {
                        self.data.start = moment(
                            self.data.start,
                            self.datePickerOptions.format
                        );
                    }
                }

                if (
                    self.data.bundle_id.length > 0 &&
                    self.data.bundle_id != null &&
                    !self.data.patient
                ) {
                    proceed = false;
                    $("#patient_id").addClass("border-danger");
                } else {
                    $("#patient_id").removeClass("border-danger");
                }

                if (
                    self.data.bundle_id.length <= 0 ||
                    self.data.bundle_id == null
                ) {
                    self.data.bundle_id = [];
                }

                if (proceed) {
                    response = await this._saveInvoice(
                        self.data,
                        self.bundle_data
                    );

                    if (response.state == 1) {
                        self._message(response.message, "danger");
                        if (response?.BDurl) {
                            window.location = response?.BDurl;
                        }
                        self.loading = false;
                    } else {
                        self.$refs.createInvoiceModal.hide();
                        if (response.action_response) {
                            self.loading = false;

                            let show_success = true;
                            let show_error = true;
                            for (
                                let i = 0;
                                i < self.data.action_response.length;
                                i++
                            ) {
                                $.each(self.data.action_response[i], function (
                                    key,
                                    value
                                ) {
                                    if (key == "uri") {
                                        window.location = value;
                                    }
                                    if (
                                        key == "success" &&
                                        show_success == true
                                    ) {
                                        show_error = true;
                                        self._message(value);
                                    }
                                    if (key == "error" && show_error == true) {
                                        show_error = false;
                                        self._message(value, "danger");
                                    }
                                });
                            }
                        }

                        let invoiceEncodedId = response.url.split("/").pop();

                        // antech v6
                        if (response.accession_id && response.antech_token) {
                            let labResponse = {};

                            if (
                                (response.lab_ids &&
                                    response.lab_ids.length > 0) ||
                                response.idexx_lab_id
                            ) {
                                labResponse = await this.getLabIntegrationObject(
                                    response,
                                    "invoice_dashboard"
                                );
                            }

                            self.$root.$emit("call-antech-iframe", {
                                antech_token: response.antech_token,
                                accession_id: response.accession_id,
                                lab_response: labResponse,
                                url: response.url
                            });

                            // go to invoice page
                            this.$router.push({
                                name: "invoice",
                                params: {
                                    id: invoiceEncodedId
                                }
                            });
                        }

                        //if have requisition form
                        else if (
                            (response.lab_ids && response.lab_ids.length > 0) ||
                            response.idexx_lab_id
                        ) {
                            let lab_response = await this.getLabIntegrationObject(
                                response,
                                "invoice_dashboard"
                            );

                            if (lab_response.idexx_iframe) {
                                //load idexx iframe
                                self.$root.$emit(
                                    "call_idexx_iframe",
                                    lab_response
                                );
                            } else {
                                //load requisition form modal
                                self.$root.$emit(
                                    "call-multirequsition-modal",
                                    lab_response
                                );
                            }
                        } else {
                            const route = {
                                name: "invoice",
                                params: {
                                    id: invoiceEncodedId
                                }
                            };

                            if (response.discount_change) {
                                route.query = { dc: 1 };
                            }

                            this.$router.push(route);
                        }
                    }

                    // return response;
                } else {
                    self.loading = false;
                }
            } else {
                self.loading = false;
            }
        }
    }
};
</script>
